import { Component } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'jquery-slimscroll';


import { AdminGuard } from './../../../_guards/admin.guard';
import { ClientGuard } from './../../../_guards/client.guard';
import { StaffGuard } from './../../../_guards/staff.guard';
import { ManagerGuard } from './../../../_guards/manager.guard';

import { User } from '../../../_models/index';

import { MysqlService } from '../../../services/mysql.service';
import { DemoService } from '../../../demo.service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


declare var jQuery:any;

@Component({
  selector: 'navigationClient',
  templateUrl: 'navigationClient.template.html'
})

export class NavigationClientComponent {

  brandMysql: any;
  currentUserID: any;
  currentPhoto: any;
  currentAccessLevel: any;
  currentBrandID: any;
  currentUser: User;
  users: User[] = [];

  sessionUserId;
  sessionUsername;
  sessionBrandId;
  sessionBrandTypeId: any;
  all_router_details: string;
  current_base_route: string;

  constructor( public router: Router,
    private _mysqlService: MysqlService, private route: ActivatedRoute,
    public _demoService: DemoService, public gfunc: GlobalFunctionsService
    ) {
    // this.currentUser = JSON.parse(sessionStorage.getItem('currentUser') as string);
    // this.currentBrandID = this.currentUser.brand_id;
    // this.currentAccessLevel = this.currentUser.access_level;
    // this.currentPhoto = this.currentUser.photo;
    // this.currentUserID = this.currentUser.user_id;

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));



    // this.getBrandMysql(this.sessionBrandId);

  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {

    jQuery('#side-menu').metisMenu();

    if (jQuery('body').hasClass('fixed-sidebar')) {
      jQuery('.sidebar-collapse').slimscroll({
        height: '100%'
      });
    }
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }


  private getBrandMysql(brand_id) {
    this._mysqlService.getMysqlBrandDatas(brand_id)
      .subscribe(
        res => this.brandMysql = res,
        err => console.log(err.error)
      );
  }




}
